<!-- =========================================================================================
    File Name: Login.vue
    Description: Login Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <b-overlay
    :show="show"
    :variant="variant"
    :opacity="opacity"
    :blur="blur"
    rounded="lg"
    spinner-variant="primary"
  >
    <b-card class="walk-card">
      <h4 class="head">
        {{ $t("Payments") }}
        <feather-icon
          id="export"
          icon="DownloadCloudIcon"
          svgClasses="w-5 h-5 hover:text-danger stroke-current"
          class="ml-5"
          :title="$t('Export')"
          v-b-modal.modal-1
        />
      </h4>
      <b-modal
        id="modal-1"
        :title="$t('ExportToExcel')"
        :ok-title="$t('Export')"
        :cancel-title="$t('Cancel')"
        @ok="exportToExcel"
        @cancel="clearFields"
        @close="clearFields"
        class="export-options"
        centered
      >
        <b-form-input
          v-model="fileName"
          class="w-full"
          :placeholder="$t('FileName')"
        ></b-form-input>
        <v-select v-model="selectedFormat" :options="formats" class="my-2"
          ><template v-slot:option="option">
            <span :class="option.icon">{{ option.label }} </span>
            <feather-icon
              v-if="selectedFormat == option.label"
              icon="CheckIcon"
              class="float-right"
              svgClasses="w-5 h-5"
            />
          </template>
        </v-select>
        <div class="flex walk-card">
          <span class="mr-3">{{ $t("CellAutoWidth") }}:</span>
          <b-form-checkbox
            v-model="cellAutoWidth"
            size="lg"
            name="cell_width"
            switch
          >
          </b-form-checkbox>
        </div>
      </b-modal>

      <!--  -->
      <!-- able -->
      <div class="mt-10">
        <b-tabs>
          <b-tab
            key="subscription_transaction"
            :title="$t('SubscriptionTransaction')"
            @click="getActiveTab('subscription_transaction')"
          >
          </b-tab>
          <b-tab
            key="transactions"
            :title="$t('AppointmentTransaction')"
            @click="getActiveTab('transactions')"
          >
          </b-tab>
        </b-tabs>
      </div>
      <div class="export-table mt-5">
        <b-col lg="5" class="my-1 p-2 float-right">
          <b-form-group
            label-for="filter-input"
            label-cols-sm="3"
            label-align-sm="right"
            label-size="sm"
            class="mb-0"
          >
            <b-input-group size="md">
              <b-input-group-prepend is-text>
                <b-icon icon="search"></b-icon>
              </b-input-group-prepend>
              <b-form-input
                id="filter-input"
                v-model="filter"
                type="search"
                :placeholder="$t('Search')"
              ></b-form-input>
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-table
          :current-page="currentPage"
          :per-page="perPage"
          :items="datas"
          :fields="index == 'transactions' ? fields : fields2"
          :busy="isBusy"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          :sort-direction="sortDirection"
          responsive
          show-empty
          :filter="filter"
          :filter-included-fields="filterOn"
          :empty-text="$t('EmptyData')"
          :empty-filtered-text="$t('EmptyFilter')"
          @filtered="onFiltered"
        >
          <template #head()="data">
            <span>{{ $t(data.label) }}</span>
          </template>
          <template #cell()="data">
            {{ data.value || "NA" }}
          </template>

          <template #cell(currency)="data">
            {{ data.item.amount + " " + data.item.currency }}
          </template>

          <template #cell(status)="data">
            {{ data.item.status == 1 ? $t("Success") : $t("Failed") }}
          </template>

          <template #cell(payment_status)="data">
            {{ data.item.payment_status ? $t("Paid") : $t("NotPaid") }}
          </template>
          <template #cell(actions)="row">
            <feather-icon
              v-b-tooltip.hover
              :title="$t('Show')"
              icon="EyeIcon"
              svgClasses="w-5 h-5 hover:text-danger stroke-current"
              class="ml-2"
              @click="$router.push(path + row.item.id)"
            />
          </template>
        </b-table>

        <b-pagination
          v-if="rows > perPage"
          v-model="currentPage"
          :total-rows="totalRows"
          :per-page="perPage"
          aria-controls="my-table"
          class="float-right"
        ></b-pagination>
      </div>
      <!--  -->
    </b-card>
  </b-overlay>
</template>

<script>
import moment from "moment";
import $ from "jquery";
import vSelect from "vue-select";
export default {
  components: {
    vSelect,
  },
  data() {
    return {
      datas: [],
      fileName: "",
      formats: ["xlsx", "csv", "txt"],
      cellAutoWidth: true,
      selectedFormat: "xlsx",
      headerTitle1: [
        "User",
        "Company",
        "Department",
        "Staff",
        "Amount",
        "Date",
        "Status",
      ],
      headerVal1: [
        "user_name",
        "company_name",
        "department",
        "staff_name",
        "amount",
        "payment_date",
        "payment_status",
      ],
      headerTitle: [
        "Plan",
        "Seats",
        "Currency",
        "TransactionId",
        "PaymentDate",
        "ExpiryDate",
        "Status",
      ],
      headerVal: [
        "plan_name",
        "seats",
        "currency",
        "transaction_id",
        "subscription_date_created_at",
        "expiry_date",
        "status",
      ],
      staffs: [],
      activePrompt: false,
      path: "/company/payments/show/",
      perPage: 10,
      currentPage: 1,
      sortBy: "",
      sortDesc: false,
      sortDirection: "asc",
      filter: null,
      filterOn: [],
      isBusy: false,
      totalRows: 1,
      show: false,
      variant: "light",
      opacity: 0.85,
      blur: "2px",
      error: "",
      success: "",
      sec: 2,
      index: "subscription_transaction",
      fields: [
        {
          key: "user_name",
          label: "User",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "company_name",
          label: "Company",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "department",
          label: "Department",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "staff_name",
          label: "Staff",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "amount",
          label: "Amount",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "payment_date",
          label: "Date",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "payment_status",
          label: "Status",
          sortable: true,
          sortDirection: "desc",
        },
        { key: "actions", label: "Action" },
      ],

      fields2: [
        {
          key: "plan_name",
          label: "Plan",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "seats",
          label: "Seats",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "currency",
          label: "Amount",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "transaction_id",
          label: "TransactionId",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "subscription_date_created_at",
          label: "PaymentDate",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "expiry_date",
          label: "ExpiryDate",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "status",
          label: "Status",
          sortable: true,
          sortDirection: "desc",
        },
      ],
    };
  },
  created() {
    this.getActiveTab("subscription_transaction");
  },

  computed: {
    rows() {
      if (this.datas) return this.datas.length;
      else return 0;
    },
  },
  methods: {
    /**
     *
     * get payment list   method
     **/
    getPaymentList(index) {
      this.show = true;

      this.$store
        .dispatch("CompanyPaymentList", this.$store.getters.currentUser.id)
        .then((res) => {
          this.show = false;
          this.datas = res.data.data[index];
          this.totalRows = this.datas.length;
        })
        .catch((error) => {
          this.$log.error(
            "File : company/payment/List.vue | Function : getPaymentList() | Error :",
            error
          );
          this.show = false;
          // Error response
          this.eror =
            this.$t(error.replace(/[\s\/]/g, "")) !==
            error.replace(/[\s\/]/g, "")
              ? this.$t(error.replace(/[\s\/]/g, ""))
              : error;
          this.$toasted.show(this.error, {
            className: "top-alert",
            position: "top-center",
            type: "error",
            duration: 2000,
          });
          return false;
        });
    },

    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },

    /**
     * vee validate with multi lang
     */
    loadLocale(code) {
      return import("vee-validate/dist/locale/" + code).then((locale) => {
        Validator.localize(code, locale);
      });
    },
    /**
     *  exportToExcel method for export file according to format
     **/
    exportToExcel() {
      import("@/assets/utils/export").then((excel) => {
        const list = this.datas;
        let headerTitle =
          this.index == "transactions" ? this.headerTitle1 : this.headerTitle;
        let headerVal =
          this.index == "transactions" ? this.headerVal1 : this.headerVal;
        headerTitle.map((title, index) => {
          headerTitle[index] = this.$t(title);
        });
        list.map((el, index) => {
          el.status = el.status == 1 ? this.$t("Success") : this.$t("Failed");

          el.payment_status = el.payment_status
            ? this.$t("Paid")
            : this.$t("NotPaid");
        });

        const data = this.formatJson(headerVal, list);
        excel.export_json_to_excel({
          header: headerTitle,
          data,
          filename: this.fileName,
          autoWidth: this.cellAutoWidth,
          bookType: this.selectedFormat,
        });
        this.headerTitle = [
          "User",
          "Company",
          "Department",
          "Staff",
          "Amount",
          "Date",
          "Status",
        ];
        this.clearFields();
      });
    },
    /**
     *  @params filterVal ,jsonData
     * formatJson   method  for export file according to format
     **/
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) =>
        filterVal.map((j) => {
          return v[j];
        })
      );
    },
    /**
     *
     * clearFields   method  for export selected format
     **/
    clearFields() {
      this.fileName = "";
      this.cellAutoWidth = true;
      this.selectedFormat = "xlsx";
    },

    getActiveTab(index) {
      this.filter = null;
      this.index = index;

      this.currentPage = 1;
      this.getPaymentList(index);
    },
  },
};
</script>

<style lang="scss">
</style>
